<template>
    <!-- layer_wrap : S -->
    <div class="layer_pop_wrap custom">
        <div class='layer_pop_dim' :style="$props.openFlag? 'display: flex; position: relative;' : 'display: none'">
            <div class="layer_pop md" :class="$props.openFlag? 'active' : ''" data-role-popup="modal_01" tabindex="0">
                <div class="pop_head">
                    <h2>공개하기</h2>
                    <button type="button" class="pop_close" @click="clickCloseHandler">닫기</button>
                </div>
                <div class="pop_cont" :key="reloadKey">
                    <div class="view_cont">
                        <ul class="column col_1">
                            <li>
                                <ul class="inp_column col_2">
                                    <li>
                                        <div class="label_txt">
                                            <span>범위<em>*</em></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div
                                                :class="cautionBlnPublic ? 'validation_error' : ''">
                                            <label for="radio0" class="component_radio">
                                                <input type="radio" id="radio0" name="rdo00" v-model="publicActive" :disabled="isUnit == true"
                                                       value="0"/>
                                                <span>비공개</span>
                                            </label>
                                            <label for="radio1" class="component_radio">
                                                <input type="radio" id="radio1" name="rdo00" v-model="publicActive" :disabled="isUnit == true"
                                                       value="1"/>
                                                <span>전체공개</span>
                                            </label>
<!--                                            <label for="radio2" class="component_radio">
                                                <input type="radio" id="radio2" name="rdo00" v-model="publicActive"
                                                       value="2"/>
                                                <span>부서공개</span>
                                            </label>-->
                                        </div>
                                    </li>
                                </ul>
                                <p v-show="cautionBlnPublic" class="validation_text"
                                   v-text="'공개 범위를 선택해주세요.'"></p>
                            </li>
                        </ul>
                        <ul class="column col_1">
                            <li>
                                <div class="label_txt">
                                    <span>문서 저장 시 필요한 정보를 입력하세요.<em>*</em></span>
                                </div>
                                <div class="column_input" :class="cautionBln ? 'validation_error' : ''">
                                    <textarea
                                            rows="15"
                                            @keyup="checkKeyUp($event)"
                                            ref="inputWrite"
                                            :value="releaseMemo"
                                            :class="cautionBln ? 'validation_error' : ''"
                                    >
                                    </textarea>
                                    <p v-show="cautionBln" class="validation_text"
                                       v-text="'필수 입력값입니다.'"></p>
                                </div>
                            </li>

                        </ul>
                        <ul class="column col_1">
                            <li>
                                <div class="label_txt">
                                    <span>선택한 공개 범위로 공개하시겠습니까?</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="pop_foot">
                    <button class="sm_btn color_1" @click="confirmHandler($event)">
                        완료
                    </button>
                </div>
            </div>
        </div>
        <div class="canvas" ref="publishCanvas"></div>
        <Loading :visible="loading" type="fixed"/>
    </div>
</template>

<script>
    import Loading from "@/components/common/loading.vue";
    import mixin from "@/mixins/process";
    import GO from "gojs";
    import {createNamespacedHelpers} from 'vuex';
    const Hub = createNamespacedHelpers('Hub');

    const goMake = GO.GraphObject.make;

    export default {
        mixins: [mixin],
        components: {
            Loading,
        },
        props: {
            openFlag: {type: Boolean, default: false},
        },
        computed: {},
        watch: {
            "$props.openFlag"(flag) {
                this.init(flag);
            }
        },
        mounted() {
            this.init(this.$props.openFlag);
        },
        data() {
            return {
                releaseCheck: false,
                releaseMemo: '',
                publicActive: 1,
                loading: false,
                editorType: null,
                processId: null,
                protocolId: null,
                keyOfProtocol: null,
                cautionBlnPublic: false,
                cautionBln: false,
                reloadKey: 0,
                diagram: {},
                isUnit: false,
            }
        },
        methods: {
            ...Hub.mapActions(['fetchDefaultExperiment']),
            async init(flag) {
                if (flag) {
                    this.loading = true;
                    this.$emit('orderApply');
                    const {editorType, processId, protocolId} = this.$route.query
                    this.editorType = editorType;
                    this.processId = processId;
                    this.protocolId = protocolId;
                    await this.getReleasData();
                    this.reloadKey++;
                    this.loading = false;
                } else { // data 초기화 하위 방식이 아니면 상위 컴포넌트에서 openFlag를 key로 선언
                    this.releaseCheck = false;
                    this.releaseMemo = '';
                    this.publicActive = 1;
                    this.loading = false;
                    this.editorType = null;
                    this.processId = null;
                    this.protocolId = null;
                    this.keyOfProtocol = null;
                    this.cautionBlnPublic = false;
                    this.cautionBln = false;
                    this.reloadKey = 0;
                    //팝업을 닫을 때 diagram 참조만 버리면 canvas 에 Diagram 이 남아 다음 공개 시 오류가 난다.
                    this.releaseDiagram(this.$refs.publishCanvas);
                }
            },
            async getReleasData() {
                try {
                    this.loading = true;
                    if (this.editorType == "process") {
                      let response = await this.$wApi.process.release.get({processId: this.processId});
                      if (response?.error || response == null) {
                          return;
                      }
                      this.releaseMemo = response?.memo;
                      //this.publicActive = response?.publicActive;
                      /*전체 공개*/
                      this.publicActive = 1;
                  }
                  /*else if (this.editorType == "protocol") {
                      let response = await this.$wApi.protocol.release.get({protocolId: this.protocolId});
                      if (response?.error || response == null) {
                          return;
                      }
                      this.releaseMemo = response?.memo;
                      this.publicActive = response?.publicActive;
                  }*/
                } catch (e) {
                    this.loading = false;
                } finally {
                    this.loading = false;
                }
            },
            async confirmHandler(event) {
              await this.confirmProcess(event);
              /*if (this.editorType == "protocol") {
                  await this.confirmProtocol(event);
              } else if (this.editorType == "process") {
                  await this.confirmProcess(event);
              }*/
            },
            async confirmProcess(event) {
                /*
                    1. process id
                    2. 공개시점 thumbnail
                    3. 공개범위
                    4. 공개메모
                    5. 유효한 keyOfProtocol
                    body 생성
                */
                try {
                    this.loading = true;
                    await this.$emit("saveDiagram",true);
                    this.cautionBlnPublic = this.publicActive == 0 ? true : false;
                    if (!this.publicActive) {
                        return;
                    }

                    this.cautionBln = !this.releaseMemo || this.releaseMemo?.length == 0 ? true : false;
                    if (!this.releaseMemo || this.releaseMemo?.length == 0) {
                        this.$refs.inputWrite.focus();
                        return;
                    }

                    let response = await this.$wApi.process.detail(null, this.processId);
                    if(JSON.parse(response.json) == null) throw new Error("공정도가 비어있어 공개할 수 없습니다.");
                    if (response?.error || response == null || response?.length == 0) {
                        window.alert("서버와 통신중 오류가 발생했습니다.<br>잠시후 다시 시도해 주세요.");
                        return;
                    }

                    let defaultExperiment = await this.fetchDefaultExperiment({processId : this.processId});
                    if(defaultExperiment?.error || defaultExperiment == null){
                      alert('공정도 노드에 속성이 존재하지 않습니다. 속성을 추가한 후 공개해주세요.');
                      return;
                    }

                    let releaseResponse = null;
                    if(this.publicActive > 0){
                      // image를 반환하며 diagram 생성.
                      let imageBase64 = await this.captureProcess(this.processId);
                      //const keyOfProtocols = this.getKeyOfProtocols(response.json);
                      releaseResponse = await this.$wApi.process.release.create({
                          processId: this.processId
                          , thumbnail: imageBase64
                          , memo: this.releaseMemo
                          , publicActive: this.publicActive
                      });
                    }else{
                      const confirmFlag = await window.confirm("정말 비공개처리하시겠습니까?");
                      if(!confirmFlag) return;
                      releaseResponse = await this.$wApi.process.release.cancel(null, this.processId);
                    }
                    if (releaseResponse?.error || releaseResponse == null) {
                        throw new Error("공개중 오류가 발생했습니다.");
                    }
                    this.loading = false;
                    this.$router.go(this.$router.currentRoute);
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                    this.init(false); // 데이터 초기화
                    this.$emit('update:openFlag', false);
                    window.alert(e.message);
                    return;
                } finally {
                    this.loading = false;
                }
            },
            //return imageBase64
            async captureProcess(id) {
                // diagram 설정
                const nodeTemplateMapped = new GO.Map();
                this.releaseDiagram(this.$refs.publishCanvas);
                this.refreshNodeStyleMap();
                this.nodeStyleMap.forEach((nodeData, key) => {
                    nodeTemplateMapped.add(
                        `${key}`,
                        goMake(
                            GO.Node, 'Auto', {
                                margin: 2,
                                // locationSpot: GO.Spot.Center,
                            },
                            new GO.Binding("location", "position", GO.Point.parse).makeTwoWay(GO.Point.stringify),
                            goMake(GO.Panel, 'Auto',
                                ...nodeData.nodeTemplate,
                            ),
                        ),
                    )
                })

                this.diagram = new GO.Diagram(this.$refs.publishCanvas, {
                    layout: goMake(GO.LayeredDigraphLayout, {
                        isOngoing: false,
                        isInitial: false
                    }),
                    // 확대 정도
                    scale: .5,
                    maxScale: 3,
                    minScale: 0.2,
                    linkTemplate: this.linkTemplate,
                    nodeTemplateMap: nodeTemplateMapped
                });
                this.diagram.isReadOnly = true;

                // 공정도 프로토콜 link로 구조 변경시 수정되어야됨. => only의 경우 공정도를 직접 그리고 캡쳐하는 방향으로 진행해야될듯
                let response = await this.$wApi.process.detail(null, id);
                const data = JSON.parse(response.json);

                this.diagram.model = new GO.GraphLinksModel(
                    {
                        nodeDataArray: data.nodes,
                        linkDataArray: data.links,
                    }
                );

                let diagramImage = this.diagram.makeImage({
                    scale: 1,
                    background: '#fff',
                    type: "image/jpeg"
                });

                return diagramImage.src.replace('data:image/jpeg;base64,', '');
            },
            getKeyOfProtocols(json) {
                const nodes = JSON.parse(json).nodes;
                const equipment = [];

                // 재귀 함수를 사용한 하위 노드 탐색. 공정, 재료 하위는 제외
                function findChildNodes(currentNode, equipment) {
                    let links = currentNode.findLinksOutOf();
                    links.each(function (link) {
                        let targetNode = link.toNode;
                        if (!(targetNode.data.category == "PROCESS" || targetNode.data.category == "MATERIAL")) {
                            if (targetNode.data.category == "EQUIPMENT") {
                                equipment.push(targetNode.data.key);
                            }
                            findChildNodes(targetNode, equipment)
                        }
                    });
                };
                for (const node of nodes) {
                    if (node?.category == "MATERIAL") {
                        const currentNode = this.diagram.findNodeForKey(node.key);
                        findChildNodes(currentNode, equipment);
                    }
                }
                return equipment;
            },
            nodeLinkValid(protocolDetail) {
                let defaultList = [];
                defaultList.push("재료");
                defaultList.push("분석목적");
                defaultList.push("측정목적");
                defaultList.push("프로토콜 기본폼");
                protocolDetail.analysis = !protocolDetail.analysis ? "" : protocolDetail.analysis; 
                protocolDetail.measurement = !protocolDetail.measurement ? "" : protocolDetail.measurement; 
                protocolDetail.equipment = !protocolDetail.equipment ? "" : protocolDetail.equipment; 
                protocolDetail.material = !protocolDetail.material ? "" : protocolDetail.material; 
                const checkAnalysis = protocolDetail.analysis.trim().length == 0 || defaultList.includes(protocolDetail.analysis) ? false : true;
                const checkMeasurement = protocolDetail.measurement.trim().length == 0 || defaultList.includes(protocolDetail.measurement) ? false : true;
                const checkEquipment = protocolDetail.equipment.trim().length == 0 || defaultList.includes(protocolDetail.equipment) ? false : true;
                const checkMaterial = protocolDetail.material.trim().length == 0 || defaultList.includes(protocolDetail.material) ? false : true;
                if (!checkMaterial || !(checkMeasurement || checkAnalysis) || !checkEquipment) {
                    return false;
                } else {
                    return true;
                }
            },
            clickCloseHandler(e) {
                e.preventDefault();
                this.init(false); // 데이터 초기화
                this.$emit('update:openFlag', false);
            },
            checkKeyUp(event) {
                this.releaseMemo = event.target.value;
            },
        }
    }
</script>